<template>
  <div class="error-container">
    <h1>Page not found</h1>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  color: #333;
  font-family: Arial, Helvetica, sans-serif;
  text-transform: uppercase;
}
</style>
